export default __webpack_public_path__ + "static/privacy-10b23a8734f2c9504fb8a389c4392a15.pdf";